import { useEffect } from "react";
import { get, set } from "@totalsoft/change-tracking-react";
import { useDebounce } from "./useDebounce";

const useDebouncedLensEffect = (lens, effect, delay = 1000) => {
  const debounceValue = useDebounce(lens |> get, delay);

  useEffect(() => {
    let lensValue = lens |> get;
    if (!lensValue) return;
    lensValue = effect(lensValue);
    (lens |> set)(lensValue);
    //The comment is necessary to keep in the dependencies of useEffect only debounceValue, because the effect should only happen if the expected time has passed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue]);
};

export { useDebouncedLensEffect };
